<template>
  <div>
    <page-header :title="$t('bill.cost_conversion')" />
    <page-body>
      <costconversion-list id="CostconversionList" />
    </page-body>
  </div>
</template>

<script>
import CostconversionList from './components/List'

export default {
  name: 'BillCostConversion',
  components: {
    CostconversionList,
  },
}
</script>
